var modules_ff399ec7 = {"container":"_1tagdhh"};
import "../../../assets/C1yE2SVL.css";

export { modules_ff399ec7 as default };
//# sourceMappingURL=ControlGroup.module.less.js.map
